module.exports = __webpack_public_path__ + "img/reimu hakurei scarlet_lw.4c0a3e5b.png";